import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { WholesaleLimitResource } from "@ploy-lib/rest-resources";
import { useResource } from "@rest-hooks/core";
import { WholesaleLimitDetail } from "./WholesaleLimitDetail";
import { ExpandableTable } from "@ploy-ui/core";
import { Grid, LinearProgress, makeStyles } from "@material-ui/core";
import { defineMessages, useIntl } from "react-intl";
const columnDefinition = (intl) => [
    {
        id: "customerId",
        label: intl.formatMessage(messages.customerIdHeader),
        hidden: { xsDown: true },
        hiddenInExpandable: { smUp: true }
    },
    {
        id: "customerName",
        label: intl.formatMessage(messages.customerNameHeader)
    },
    {
        id: "limitRemaining",
        label: intl.formatMessage(messages.limitRemainingHeader),
        hidden: { smDown: true }
    },
    {
        id: "limit",
        label: intl.formatMessage(messages.limitHeader)
    },
    {
        id: "sumView",
        label: intl.formatMessage(messages.sumViewHeader)
    },
    {
        id: "sumApproved",
        label: intl.formatMessage(messages.sumApprovedHeader)
    },
    {
        id: "other",
        label: intl.formatMessage(messages.otherHeader),
        hiddenInExpandable: { mdUp: true }
    }
];
const useStyles = makeStyles(theme => ({
    expandedColumn: {
        padding: 0
    }
}));
const messages = defineMessages({
    customerIdHeader: {
        id: "dealer.wholesalelimit.table.header.customerid",
        description: "header for wholesalelimit table, column customerId",
        defaultMessage: "KundeId"
    },
    customerNameHeader: {
        id: "dealer.wholesalelimit.table.header.customername",
        description: "header for wholesalelimit table, column customerName",
        defaultMessage: "Kunde"
    },
    limitRemainingHeader: {
        id: "dealer.wholesalelimit.table.header.limitremaining",
        description: "header for wholesalelimit table, column limitRemaining",
        defaultMessage: "Gjenværende grense"
    },
    limitHeader: {
        id: "dealer.wholesalelimit.table.header.limit",
        description: "header for wholesalelimit table, column limit",
        defaultMessage: "Grense"
    },
    sumViewHeader: {
        id: "dealer.wholesalelimit.table.header.sumview",
        description: "header for wholesalelimit table, column sumView",
        defaultMessage: "Benyttet"
    },
    sumApprovedHeader: {
        id: "dealer.wholesalelimit.table.header.sumapproved",
        description: "header for wholesalelimit table, column sumApproved",
        defaultMessage: "Godkjent avrop"
    },
    otherHeader: {
        id: "dealer.wholesalelimit.table.header.other",
        description: "header for wholesalelimit table, column other",
        defaultMessage: "Andre forpliktelser"
    }
});
const WholesaleLimit = (props) => {
    const { vendorId } = props;
    const classes = useStyles();
    const intl = useIntl();
    const wholesaleLimitData = useResource(WholesaleLimitResource.list(), {
        vendorId: vendorId
    });
    return (_jsx(Grid, { container: true, item: true, spacing: 3, xs: 12, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(ExpandableTable, { idColumn: "vendorId", tableData: wholesaleLimitData, columnData: columnDefinition(intl), renderExpandedSection: datarow => datarow.vendorId && (_jsx(Suspense, { fallback: _jsx(LinearProgress, {}), children: _jsx(WholesaleLimitDetail, { vendorId: datarow.vendorId }) })), classes: classes }) }) }));
};
export { WholesaleLimit };
//# sourceMappingURL=WholesaleLimit.js.map